import { styled, Theme } from '@mui/material';
import { CoreDialog } from '@youscience/core';

export const sxStyles = {
  content: {
    maxWidth: '540px',
    margin: '0 auto',
    padding: '2.5rem 1rem',
  },
  titles: {
    textAlign: 'center',

    '& > p:last-of-type': {
      margin: '1rem 0 ',
    },
  },
  formWrap: {
    padding: '0 1.75rem',
  },
  alert: {
    display: 'flex',
    marginBottom: '1rem',
    alignItems: 'start',
    maxWidth: '450px',
  },
  shareInfo: (theme: Theme) => ({
    marginTop: '2.5rem',
    color: '#666666',

    '& > span:first-of-type': {
      color: theme.palette.primary.main,
      cursor: 'pointer',
    },
  }),
};

export const StyledDialog = styled(CoreDialog)(() => ({
  '.MuiPaper-root': {
    maxWidth: '720px',
    width: '100%',
    borderRadius: '12px',
  },
}));
